import api from "./api";
import fileDownload from "js-file-download";

// Ordenação das listagens, resolvida no SERVIDOR porque a paginação também é —
// ordenar só a página à vista mostraria "o que vence antes" apenas dentro dos 15
// registros carregados. No LOTE, "vencimento" é o da próxima parcela EM ABERTO:
// o lote em si não tem data de vencimento, tem um carnê inteiro delas.
export const ORDEM = {
  CRIACAO: "criacao",
  VENCIMENTO: "vencimento",
};

export default class ListaBoletoAPI {
  static getBolepix = async (
    page: number,
    recordsPerPage: number,
    idCliente: number,
    search: string = "",
    valorInicio: number = 0,
    valorFim: number = 0,
    idStatus: number = 0,
    ModoPgto: number = 5,
    isAvulso: boolean = false,
    dataInicio?: string,
    dataFim?: string,
    idLote?: string,
    clientFilter?: string,
    issuanceDateInicio?: string,
    issuanceDateFim?: string,
    dueDateInicio?: string,
    dueDateFim?: string,
    documentFilter?: string,
    IdLote?: string,
    numeroDocumento?: string,
    emailPagador?: string,
    telefone?: string,
    // Data de PAGAMENTO — junto com o vencimento, é o filtro que a operação
    // mais usa ("o que entrou ontem"). Entra no fim para não deslocar os
    // parâmetros posicionais já existentes.
    paymentDateInicio?: string,
    paymentDateFim?: string,
    // ORDEM.CRIACAO (padrão) | ORDEM.VENCIMENTO
    ordenarPor?: string,
    statusBolepix?: "pendente"
  ) => {
    const params = new URLSearchParams();

    params.append("Page", page.toString());
    params.append("RecordsPerPage", recordsPerPage.toString());
    params.append("idCliente", idCliente.toString());

    if (search) params.append("Search", search);
    if (valorInicio > 0) params.append("valorInicio", valorInicio.toString());
    if (valorFim > 0) params.append("valorFim", valorFim.toString());
    if (idStatus > 0) params.append("idStatus", idStatus.toString());
    if (ModoPgto !== 5) params.append("ModoPgto", ModoPgto.toString());
    if (isAvulso) params.append("isavulso", "true");

    if (dataInicio) params.append("dataInicio", dataInicio);
    if (dataFim) params.append("dataFim", dataFim);
    if (idLote) params.append("idLote", idLote);
    // filtro "Cliente" busca pelo NOME DO PAGADOR
    if (clientFilter) params.append("nomePagador", clientFilter);
    if (issuanceDateInicio)
      params.append("dtEmissaoInicio", issuanceDateInicio);
    if (issuanceDateFim) params.append("dtEmissaoFim", issuanceDateFim);
    if (dueDateInicio) params.append("dtVencimentoInicio", dueDateInicio);
    if (dueDateFim) params.append("dtVencimentoFim", dueDateFim);
    if (paymentDateInicio) params.append("dtPagamentoInicio", paymentDateInicio);
    if (paymentDateFim) params.append("dtPagamentoFim", paymentDateFim);
    if (ordenarPor) params.append("ordenarPor", ordenarPor);
    if (statusBolepix) params.append("statusBolepix", statusBolepix);
    // "CPF/CNPJ Pagador" na UI → filtro cpfPagador no backend
    if (documentFilter) params.append("cpfPagador", documentFilter);
    if (IdLote) params.append("IdLote", IdLote);
    if (numeroDocumento) params.append("numeroDocumento", numeroDocumento);
    if (emailPagador) params.append("emailPagador", emailPagador);
    if (telefone) params.append("telefone", telefone);

    const url = `/Bolepix?${params.toString()}`;
    return await api.get(url);
  };

  static getBolepixLote = async (
    page: number,
    recordsPerPage: number,
    idCliente: number,
    search: string = "",
    valorInicio: number = 0,
    valorFim: number = 0,
    idStatus: number = 0,
    ModoPgto: number = 5,
    dataInicio?: string,
    dataFim?: string,
    clientFilter?: string,
    issuanceDateInicio?: string,
    issuanceDateFim?: string,
    dueDateInicio?: string,
    dueDateFim?: string,
    documentFilter?: string,
    IdLote?: string,
    paymentDetailsFilter?: string,
    emailPagador?: string,
    telefone?: string,
    // No lote, vencimento e pagamento filtram pelas PARCELAS: a core devolve o
    // lote que tem ao menos uma parcela no período.
    paymentDateInicio?: string,
    paymentDateFim?: string,
    // ORDEM.CRIACAO (padrão) | ORDEM.VENCIMENTO
    ordenarPor?: string
  ) => {
    const params = new URLSearchParams();

    params.append("Page", page.toString());
    params.append("RecordsPerPage", recordsPerPage.toString());
    params.append("idCliente", idCliente.toString());

    if (search) params.append("Search", search);
    if (dataInicio) params.append("dataInicio", dataInicio);
    if (dataFim) params.append("dataFim", dataFim);
    if (valorInicio > 0) params.append("valorInicio", valorInicio.toString());
    if (valorFim > 0) params.append("valorFim", valorFim.toString());
    if (idStatus > 0) params.append("idStatus", idStatus.toString());
    if (ModoPgto !== 5) params.append("ModoPgto", ModoPgto.toString());
    // filtro "Cliente" busca pelo NOME DO PAGADOR
    if (clientFilter) params.append("nomePagador", clientFilter);
    if (issuanceDateInicio)
      params.append("dtEmissaoInicio", issuanceDateInicio);
    if (issuanceDateFim) params.append("dtEmissaoFim", issuanceDateFim);
    if (dueDateInicio) params.append("dtVencimentoInicio", dueDateInicio);
    if (dueDateFim) params.append("dtVencimentoFim", dueDateFim);
    if (paymentDateInicio) params.append("dtPagamentoInicio", paymentDateInicio);
    if (paymentDateFim) params.append("dtPagamentoFim", paymentDateFim);
    if (ordenarPor) params.append("ordenarPor", ordenarPor);
    // "CPF/CNPJ Pagador" na UI → filtro cpfPagador no backend
    if (documentFilter) params.append("cpfPagador", documentFilter);
    if (IdLote) params.append("IdLote", IdLote);
    if (paymentDetailsFilter)
      params.append("paymentDetailsFilter", paymentDetailsFilter);
    if (emailPagador) params.append("emailPagador", emailPagador);
    if (telefone) params.append("telefone", telefone);

    const url = `/bolepix/consultar-lote?${params.toString()}`;
    return await api.get(url);
  };

  static cancelBatch = async (id: string) => {
    const url = `/bolepix/cancelar-lote/${id}`;
    const response = await api.post(url);
    return response;
  };

  static downloadBatch = async (idLote: string, token: string) => {
    try {
      const url = `/bolepix/download/lote/${idLote}`;
      const response = await api.get(url, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: "blob",
      });
      fileDownload(response.data, `lote_${idLote}.pdf`);
      return response;
    } catch (error) {
      console.error("Error downloading batch:", error);
      throw error;
    }
  };
  // Reemite manualmente uma parcela que falhou. Sem corpo: a core remonta o
  // payload da Zoop a partir do banco (parcela + lote + taxas do lote).
  static reemitirParcela = async (idBoleto: string) => {
    const response = await api.post(`/bolepix/parcela/${idBoleto}/reemitir`);
    return response.data;
  };

  static exportBolepix = async (
    idCliente: number,
    search: string = "",
    valorInicio: number = 0,
    valorFim: number = 0,
    idStatus: number = 0,
    ModoPgto: number = 5,
    isAvulso: boolean = false,
    dataInicio?: string,
    dataFim?: string,
    idLote?: string,
    clientFilter?: string,
    issuanceDateInicio?: string,
    issuanceDateFim?: string,
    dueDateInicio?: string,
    dueDateFim?: string,
    documentFilter?: string,
    IdLote?: string,
    numeroDocumento?: string,
    emailPagador?: string,
    telefone?: string,
    isLote: boolean = false,
    // o XLSX tem que sair com os MESMOS filtros da tela — sem isto, filtrar por
    // pagamento e exportar devolvia um arquivo diferente do que estava à vista
    paymentDateInicio?: string,
    paymentDateFim?: string
  ) => {
    const params = new URLSearchParams();

    params.append("idCliente", idCliente.toString());

    if (search) params.append("Search", search);
    if (valorInicio > 0) params.append("valorInicio", valorInicio.toString());
    if (valorFim > 0) params.append("valorFim", valorFim.toString());
    if (idStatus > 0) params.append("idStatus", idStatus.toString());
    if (ModoPgto !== 5) params.append("ModoPgto", ModoPgto.toString());
    if (isAvulso) params.append("isavulso", "true");

    if (dataInicio) params.append("dataInicio", dataInicio);
    if (dataFim) params.append("dataFim", dataFim);
    if (idLote) params.append("idLote", idLote);
    // filtro "Cliente" busca pelo NOME DO PAGADOR
    if (clientFilter) params.append("nomePagador", clientFilter);
    if (issuanceDateInicio)
      params.append("dtEmissaoInicio", issuanceDateInicio);
    if (issuanceDateFim) params.append("dtEmissaoFim", issuanceDateFim);
    if (dueDateInicio) params.append("dtVencimentoInicio", dueDateInicio);
    if (dueDateFim) params.append("dtVencimentoFim", dueDateFim);
    if (paymentDateInicio) params.append("dtPagamentoInicio", paymentDateInicio);
    if (paymentDateFim) params.append("dtPagamentoFim", paymentDateFim);
    // "CPF/CNPJ Pagador" na UI → filtro cpfPagador no backend
    if (documentFilter) params.append("cpfPagador", documentFilter);
    if (IdLote) params.append("IdLote", IdLote);
    if (numeroDocumento) params.append("numeroDocumento", numeroDocumento);
    if (emailPagador) params.append("emailPagador", emailPagador);
    if (telefone) params.append("telefone", telefone);

    // Rota diferenciada por tipo (individual ou lote)
    const endpoint = isLote ? `/bolepix/download` : `/bolepix/download`;

    const url = `${endpoint}?${params.toString()}`;

    try {
      const response = await api.get(url, {
        responseType: "blob",
      });
      return response;
    } catch (error) {
      console.error("Erro ao exportar relatório:", error);
      throw error;
    }
  };
  static getCalendarData = async (
    dataInicio: string,
    dataFim: string,
    idCliente: number,
    clientFilter?: string,
    // "vencimento" (padrão) = dia em que os boletos vencem
    // "recebimento" = dia em que o dinheiro caiu no extrato
    eixo?: "vencimento" | "recebimento"
  ) => {
    const params = new URLSearchParams();
    params.append("dataInicio", dataInicio);
    params.append("dataFim", dataFim);
    params.append("idCliente", idCliente.toString());
    if (eixo) params.append("eixo", eixo);
    // filtro "Cliente" busca pelo NOME DO PAGADOR
    if (clientFilter) params.append("nomePagador", clientFilter);

    const url = `/bolepix/calendar?${params.toString()}`;
    return await api.get(url);
  };

  static downloadIndividual = async (idBoleto: string, token: string) => {
    try {
      const url = `/bolepix/download/individual/${idBoleto}`;
      const response = await api.get(url, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: "blob",
      });
      fileDownload(response.data, `boleto_${idBoleto}.pdf`);
      return response;
    } catch (error) {
      console.error("Error downloading individual:", error);
      throw error;
    }
  };
}
